import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, legacy_createStore, compose } from 'redux';
import soundsMiddleware from 'redux-sounds';
import './styles/app.css';
import './fontawesome/css/all.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import reducer from './reducers/reducer';

const soundData = {
	intro: 'content/audio/intro.mp3',
};

const loadedSoundsMiddleware = soundsMiddleware(soundData);

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const enhancer = composeEnhancers(
	applyMiddleware(loadedSoundsMiddleware)
);

const store = legacy_createStore(reducer, enhancer);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();

export default store;
